var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-green",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('trigger')}}},[_vm._v(" Tilbage ")])}
var staticRenderFns = []

export { render, staticRenderFns }